import { useQuery } from '@tanstack/react-query';

import { dashboardV2Client } from '../api/client';
import { dashboardLiveQueryOptions } from '../api/liveQuery';
import { dashboardV2QueryKeys } from '../api/queryKeys';
import {
  DEFAULT_QUEUE_PAGE,
  EMPTY_QUEUE_FILTERS,
  NoShowData,
  QueueFilterValues,
  QueuePage,
} from '../api/types';

// Outstanding no-show worker instances grouped by shift. Kept lightly fresh so
// the queue reflects new no-shows / resolutions without a manual reload.
const useNoShowQueue = (
  agencyId: number,
  filters: QueueFilterValues = EMPTY_QUEUE_FILTERS,
  page: QueuePage = DEFAULT_QUEUE_PAGE,
) =>
  useQuery<NoShowData>({
    queryKey: dashboardV2QueryKeys.noShow(agencyId, filters, page),
    queryFn: () => dashboardV2Client.getNoShow(agencyId, filters, page),
    enabled: agencyId != null,
    ...dashboardLiveQueryOptions,
  });

export default useNoShowQueue;
